"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentIconMapSource = void 0;
exports.contentIconMapSource = {
    'rrn:content:apple-immersive-videos': { iconName: 'asset-vr' },
    'rrn:content:audio-clips': { iconName: 'audio' },
    'rrn:content:audio-episodes': { iconName: 'asset-podcast-episode' },
    'rrn:content:audio-seasons': { iconName: 'asset-season' },
    'rrn:content:audio-series': { iconName: 'asset-podcast-show' },
    'rrn:content:collections': {
        iconName: 'asset-content-collection',
        subType: {
            editoriallist: { iconName: 'asset-editoriallist' },
            playlist: { iconName: 'asset-playlist' },
        },
    },
    'rrn:content:editorial-lists': { iconName: 'asset-collection' },
    'rrn:content:energy-drinks': { iconName: 'can' },
    'rrn:content:episode-videos': { iconName: 'asset-episode' },
    'rrn:content:event-details': { iconName: 'asset-event-details' },
    'rrn:content:event-profiles': { iconName: 'asset-event' },
    'rrn:content:event-seasons': { iconName: 'asset-season' },
    'rrn:content:event-series': { iconName: 'asset-eventseries' },
    'rrn:content:external-persons': { iconName: 'asset-person' },
    'rrn:content:external-teams': { iconName: 'asset-partner' },
    'rrn:content:externals': { iconName: 'asset-ecr' },
    'rrn:content:films': { iconName: 'asset-film' },
    'rrn:content:image-galleries': { iconName: 'asset-gallery' },
    'rrn:content:images': { iconName: 'asset-image' },
    'rrn:content:immersive-3d-models': { iconName: 'asset-vr' },
    'rrn:content:judges': { iconName: 'asset-person' },
    'rrn:content:live-videos': { iconName: 'asset-live-video' },
    'rrn:content:locations': { iconName: 'asset-location' },
    'rrn:content:occasion-campaigns': { iconName: 'asset-page-occasion' },
    'rrn:content:occasions': { iconName: 'asset-page-occasion' },
    'rrn:content:onsite-promotions': { iconName: 'can-inverted' },
    'rrn:content:partner-profiles': { iconName: 'asset-partner' },
    'rrn:content:person-profiles': {
        iconName: 'asset-person',
        subType: {
            athlete: { iconName: 'asset-person' },
            artist: { iconName: 'asset-person' },
        },
    },
    'rrn:content:photographers': { iconName: 'asset-person' },
    'rrn:content:playlists': { iconName: 'asset-playlist' },
    'rrn:content:preview-clips': { iconName: 'asset-preview-clips' },
    'rrn:content:project-profiles': { iconName: 'asset-project' },
    'rrn:content:rally-drivers': { iconName: 'asset-person' },
    'rrn:content:recap-videos': { iconName: 'asset-recap-video' },
    'rrn:content:results-standings': { iconName: 'results' },
    'rrn:content:seasons': { iconName: 'asset-season' },
    'rrn:content:shows': { iconName: 'asset-show' },
    'rrn:content:stories': { iconName: 'asset-story' },
    'rrn:content:tags': { iconName: 'asset-tag' },
    'rrn:content:team-profiles': { iconName: 'asset-partner' },
    'rrn:content:trailer-videos': { iconName: 'asset-trailer' },
    'rrn:content:tv-commercials': { iconName: 'asset-page-occasion' },
    'rrn:content:video-3d': { iconName: 'asset-vr' },
    'rrn:content:video-channels': { iconName: 'asset-video-channel' },
    'rrn:content:videos': { iconName: 'asset-video' },
    'rrn:content:videos-360': { iconName: 'asset-vr' },
    'rrn:content:author-profiles': { iconName: 'pen' },
    'rrn:content:misc': { iconName: 'asset-content-collection' },
    'rrn:content:tv-partner-channels': { iconName: 'devices' },
    'rrn:content:rally-teams': { iconName: 'asset-partner' },
};
//# sourceMappingURL=content-icon-map.js.map